<template>
<el-card  :body-style="{width: '100%'}">
  <div class="list-tile">
    <font-awesome-icon class="list-tile__icon" :icon="icon"/>
    <div class="list-tile__content">
      <span class="list-tile__content__title">{{ title }}</span>
      <span class="list-tile__content__subtitle"> {{ subtitle }}</span>
    </div>
    <span class="list-tile__trailing">
      {{ trailingText }}
    </span>
  </div>
</el-card>
</template>

<script>
export default {
  name: 'ServiceTile',
  props: {
    icon: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    trailingText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.list-tile{
  display: flex;
  &__icon{
    width: 32px;
    height: 32px;
  }
  &__content{
    flex-grow: 2;
    margin: 0  10px;
    display: flex;
    flex-direction: column;
    text-transform: uppercase;
    &__title{
      font-weight: bold;
      font-size: $--font-size-large;
    }
    &__subtile{
      font-size: $--font-size-medium;
    }
  }
  &__trailing{
    font-weight: bold;
  }
}
</style>
